import readingFox from "../../assets/reading-fox.png";
import "./activity-hero.scss";

/** Shared entry layout with activity-specific copy. */
export function ActivityHero({ title = "מה נלמד היום?" }: { title?: string }) {
  return <div className="activity-hero">
    <img src={readingFox} alt="" draggable={false} />
    <h1>{title}</h1>
  </div>;
}
